export default __webpack_public_path__ + "static/media/Montserrat-Regular.65bc44fb.otf";